import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Company, User } from "@models";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GroupService, UtilsService } from "@services";

@Component({
  selector: "app-user-form-group",
  templateUrl: "./user-form-group.component.html",
  styleUrls: ["./user-form-group.component.scss"],
})
export class UserFormGroupComponent implements OnInit {
  @Input() user: User;
  @Input() department: any;
  @Input() travelPolicies: any;
  @Input() company: Company;
  @Input() loading: Boolean;
  @Output() sendInfo = new EventEmitter<any>();

  departments: any[] = [];
  form: UntypedFormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private groupService: GroupService,
    public utilsService: UtilsService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      group: [this.department ? this.department : "", [Validators.required]],
    });
    if (!this.travelPolicies.filters.onlyAuthorization) {
      this.travelPolicies.filters.onlyAuthorization = false;
    }
    if (this.company) {
      this.groupService
        .getGroups(this.company.uuid)
        .subscribe((data: any[]) => {
          this.departments = data;
        });
    }
  }

  compareFn(a: any, b: any) {
    return a && b && a.uuid === b.uuid;
  }

  get f() {
    return this.form.controls;
  }

  onSubmit() {
    const userInfo: any = {
      group: this.f.group.value,
    };

    this.sendInfo.emit(userInfo);
  }

  closeModal() {
    this.activeModal.dismiss("Cross click");
  }
}
